import { Key } from '../enums/Keyboard';

const isEnter = (key: string) => key === Key.Enter;
const isSpace = (key: string) => key === Key.Space;
const isExit = (key: string) => key === Key.Esc;

export const getEnterHandler =
  (callback: (e?: KeyboardEvent | React.KeyboardEvent<unknown>) => void) =>
  (e: KeyboardEvent | React.KeyboardEvent<unknown>) => {
    if (isSpace(e.key)) {
      e.preventDefault();
      callback(e);
    } else if (isEnter(e.key)) {
      callback(e);
    }
  };

export const getEnterExitHandler =
  (handler: () => void) =>
  ({ key }: KeyboardEvent) => {
    if (isExit(key)) handler();
  };

export const swallowEnter = (e: React.KeyboardEvent<unknown> | KeyboardEvent) => {
  if (e.key === Key.Enter) e.preventDefault();
};
